export const DEFAULT_LANGUAGE = 'pt';
export const SUPPORTED_LANGUAGES = ['pt', 'en'];

const translations = {
  pt: {
    common: {
      languageLabel: 'Idioma',
      languageToggle: 'Mudar para {language}',
      approxLocationNote: 'Detectamos o idioma automaticamente pela sua região.',
      menuLabel: 'Menu',
      copyright: '© 2025 AlgorCode Tecnologia. Todos os direitos reservados.'
    },
    navigation: {
      home: 'Home',
      blog: 'Blog',
      about: 'Sobre nós',
      careers: 'Trabalhe conosco',
      contact: 'Contato'
    },
    hero: {
      paragraph: 'Desenvolvemos sistemas sob demanda, customizados do seu jeito, buscando sempre aprimorar os seus resultados.',
      primaryCta: 'Fale Conosco',
      secondaryCta: 'Sobre nós',
      secondaryCtaAria: 'Ir para a página Sobre nós'
    },
    featuresTiles: {
      header: {
        title: 'Aplicativos, sites ou sistemas',
        paragraph: 'Desenvolvemos aplicações Web, Desktop e Mobile com tecnologias de ponta.'
      },
      tiles: [
        {
          title: 'Sites',
          description: 'Seu negócio precisa de um website moderno? A AlgorCode desenvolve e publica na internet pra você.'
        },
        {
          title: 'Aplicativos',
          description: 'Precisou de um aplicativo para iOS ou Android? Nosso time desenvolve do jeitinho que você precisa.'
        },
        {
          title: 'E-commerces',
          description: 'Que tal vender os seus produtos na internet? Temos uma loja virtual perfeita pra você!'
        }
      ]
    },
    featuresSplit: {
      header: {
        title: 'O poder da tecnologia.',
        paragraph: 'Através do poder transformador da tecnologia, podemos impulsionar suas ferramentas digitais, trazendo ainda mais resultados.'
      },
      items: [
        {
          eyebrow: 'Automações de processos manuais',
          title: 'Multiplique seus recursos!',
          description: 'Automatizando processos manuais você estará liberando recursos humanos para atividades de mais impacto! Emails, relatórios, suporte a clientes... Vamos automatizar?'
        },
        {
          eyebrow: 'Suporte e qualidade de serviço',
          title: 'Seu sistema é nossa prioridade!',
          description: 'Todos os nossos sistemas passam por rigorosos fluxos de teste, e você terá sempre à disposição um time capacitado para te ajudar.'
        },
        {
          eyebrow: 'Data warehouse',
          title: 'O poder dos seus dados.',
          description: 'Quanto mais analisados são os seus dados, maior é o conhecimento do seu negócio. Conheça também nosso serviço de análise de dados!'
        }
      ]
    },
    cta: {
      title: 'Como podemos te ajudar?',
      action: 'Fale Conosco'
    },
    notFound: {
      title: 'Página não encontrada!',
      description: 'Verifique o endereço ou volte para a página inicial.'
    },
    notImplemented: {
      title: 'Página ainda não criada!',
      description: 'Em breve esta página será implementada.'
    },
    aboutWelcome: {
      header: {
        title: 'Transformando desafios em oportunidades',
        paragraph: 'Conheça a nossa recente história e como transformamos desafios em oportunidades.'
      }
    },
    aboutHistory: {
      header: {
        title: 'Conheça nossa história',
        paragraph: 'Descubra como tudo começou e como ajudamos as empresas a serem mais eficientes.'
      },
      items: [
        {
          eyebrow: 'O início da nossa história',
          title: 'Quando tudo começou',
          description: 'Criada em 2022 com a visão de transformar a forma como as empresas lidam com seus desafios diários. Com a nossa equipe de especialistas em tecnologia, desenvolvemos aplicações inovadoras que ajudam as empresas a serem mais produtivas, eficientes e competitivas.'
        },
        {
          eyebrow: 'Alvos a atingir',
          title: 'Metas a serem alcançadas',
          description: 'Nosso objetivo é ser uma parceira estratégica para nossos clientes, oferecendo soluções tecnológicas personalizadas que atendam às suas necessidades específicas. Estamos comprometidos em estar sempre à frente das tendências do mercado.'
        },
        {
          eyebrow: 'Impulsionados por nossa paixão pela tecnologia',
          title: 'A parceria estratégica que sua empresa precisa',
          description: 'Criamos a AlgorCode com a paixão de mudar a forma como as coisas são feitas e acreditamos que, juntos, podemos alcançar resultados incríveis. Estamos ansiosos para trabalhar com você e ajudar sua empresa a alcançar seus objetivos.'
        }
      ]
    },
    contactIntro: {
      title: 'Vamos conversar?',
      description: 'Planejamos, desenhamos e construímos soluções digitais sob medida. Escolha o canal preferido ou envie uma mensagem pelo formulário abaixo.',
      whatsapp: 'Falar pelo WhatsApp',
      message: 'Escrever mensagem'
    },
    contactChannels: {
      header: {
        title: 'Como prefere falar com a gente?',
        paragraph: 'Estamos disponíveis para tirar dúvidas, discutir ideias e entender seu projeto em diferentes canais.'
      },
      whatsapp: {
        title: 'Suporte imediato',
        description: 'Converse em tempo real com o time pelo WhatsApp. Atendimento de segunda a sexta, das 9h às 18h (BRT).',
        cta: 'Abrir WhatsApp'
      },
      email: {
        title: 'Envie um email',
        description: 'Centralize as informações do seu projeto e receba uma resposta em até um dia útil via {email}.',
        cta: 'Enviar email'
      },
      meeting: {
        title: 'Projetos e propostas',
        description: 'Marque uma chamada para entender o escopo, apresentar referências e estimar prazos e investimentos.',
        cta: 'Solicitar reunião'
      }
    },
    contactForm: {
      header: {
        title: 'Envie uma mensagem',
        description: 'Compartilhe um resumo do que precisa e retornamos com os próximos passos em até um dia útil.'
      },
      fields: {
        name: {
          label: 'Nome',
          placeholder: 'Como devemos te chamar?'
        },
        email: {
          label: 'Email',
          placeholder: 'Melhor email para contato'
        },
        company: {
          label: 'Empresa',
          placeholder: 'Nome da empresa (opcional)'
        },
        phone: {
          label: 'Telefone',
          placeholder: '(11) 99999-9999'
        },
        message: {
          label: 'Mensagem',
          placeholder: 'Conte resumidamente os desafios ou objetivos do projeto'
        }
      },
      subjectPrefix: 'Contato pelo site',
      fallbackProject: 'novo projeto',
      submit: 'Enviar mensagem',
      feedback: 'Abrimos o seu aplicativo de email. Se não funcionar, escreva para {email}.'
    },
    contactConfirmation: {
      title: 'Agradecemos o seu contato!',
      description: 'Agora é só aguardar que entraremos em contato assim que possível.'
    },
    careers: {
      hero: {
        title: 'Faça parte do nosso time!',
        description: 'Procuramos pessoas curiosas, colaborativas e focadas em resultado. Aqui você encontra autonomia para propor ideias, apoio para se desenvolver e espaço para trabalhar com tecnologia de ponta.',
        primaryCta: 'Ver vagas abertas',
        secondaryCta: 'Enviar currículo'
      },
      reasons: {
        header: {
          title: 'Por que construir conosco?',
          paragraph: 'Nosso foco é unir tecnologia, negócio e colaboração para gerar impacto real.'
        },
        highlights: [
          {
            title: 'Stack moderna',
            description: 'Construímos produtos usando React, Node, AWS, automações e dados para acelerar a entrega de valor.'
          },
          {
            title: 'Autonomia com apoio',
            description: 'Times pequenos, feedback contínuo e planos individuais de desenvolvimento garantem aprendizado diário.'
          },
          {
            title: 'Cultura remota',
            description: 'Somos remotos por padrão, com encontros presenciais opcionais a cada trimestre para aproximar o time.'
          },
          {
            title: 'Impacto real',
            description: 'Atuamos junto aos clientes desde a descoberta até o deploy, sempre conectando tecnologia a resultados.'
          }
        ]
      },
      openings: {
        header: {
          title: 'Vagas abertas',
          paragraph: 'Todas as oportunidades são 100% remotas. Candidaturas de qualquer lugar do Brasil são bem-vindas.'
        },
        subjectPrefix: 'Candidatura - ',
        positions: [
          {
            title: 'Desenvolvedor(a) Front-end Sênior',
            type: 'Remoto',
            description: 'Lidera evolução de produtos, define arquitetura de componentes e mentora o time.',
            tags: ['React', 'TypeScript', 'Design System']
          },
          {
            title: 'Product Designer Pleno',
            type: 'Remoto',
            description: 'Conduz pesquisas, prototipação e testes para criar experiências simples e consistentes em múltiplos canais.',
            tags: ['Discovery', 'Figma', 'Design Ops']
          },
          {
            title: 'QA Engineer',
            type: 'Remoto',
            description: 'Cria estratégias de teste, automatiza cenários-chave e garante observabilidade do ciclo de entrega.',
            tags: ['Automação', 'Cypress', 'CI/CD']
          }
        ],
        cta: 'Quero me candidatar',
        fallback: 'Não encontrou uma oportunidade para você? Envie um email para {email} contando como pode contribuir.'
      },
      process: {
        header: {
          title: 'Nosso processo seletivo',
          paragraph: 'Transparência e agilidade do primeiro contato ao feedback final.'
        },
        stepLabel: 'Etapa {step}',
        steps: [
          {
            title: 'Envio e triagem',
            description: 'Analisamos currículo, portfólio e links para entender sua trajetória e interesses.'
          },
          {
            title: 'Conversa com o time',
            description: 'Bate-papo de 30 minutos para conhecer mais você, tirar dúvidas e falar sobre cultura.'
          },
          {
            title: 'Desafio técnico leve',
            description: 'Case prático ou pairing com o time para avaliação colaborativa das suas habilidades.'
          },
          {
            title: 'Feedback e proposta',
            description: 'Retorno rápido, independente do resultado, com convite para avançar quando houver aderência.'
          }
        ]
      },
      finalCta: {
        title: 'Vamos construir algo grande juntos?',
        description: 'Conte para a gente o que você quer criar, quais desafios te motivam e como podemos colaborar.',
        action: 'Entrar em contato'
      }
    },
    blogFeatured: {
      title: 'AlgorBlog',
      articles: [
        {
          tags: ['Automações', 'Suporte'],
          title: 'Aumente sua produtividade automatizando tarefas rotineiras com bots e scripts',
          description: 'Como chatbots podem melhorar a experiência de clientes e facilitar o processo de interação e suporte.',
          author: 'Por Deoclides Neto - 1 de março de 2017',
          link: '#0'
        },
        {
          tags: ['Soft Skill'],
          title: 'Você nunca é bom demais para o básico',
          description: 'Todo mundo quer conhecimento avançado. Mas normalmente é o básico que mais importa.',
          author: 'Por Leonardo Lins - 3 de agosto de 2022',
          link: '#0'
        },
        {
          tags: ['Inteligência Artificial', 'Visão Computacional'],
          title: 'Como a Rede Neural Convolucional vê o mundo?',
          description: 'Muitas redes neurais de última geração estão facilmente disponíveis para desenvolvedores hoje, mas como isso realmente funciona?',
          author: 'Por Dmitri Eliuseev - 5 de agosto de 2022',
          link: 'https://medium.com/@dmitryelj/how-the-convolutional-neural-network-see-the-world-a36cd102e7c8'
        }
      ]
    }
  },
  en: {
    common: {
      languageLabel: 'Language',
      languageToggle: 'Switch to {language}',
      approxLocationNote: 'We detected your language automatically using your region.',
      menuLabel: 'Menu',
      copyright: '© 2025 AlgorCode Tecnologia. All rights reserved.'
    },
    navigation: {
      home: 'Home',
      blog: 'Blog',
      about: 'About us',
      careers: 'Careers',
      contact: 'Contact'
    },
    hero: {
      paragraph: 'We build bespoke software that matches your needs and continually improves your results.',
      primaryCta: 'Chat with us',
      secondaryCta: 'About us',
      secondaryCtaAria: 'Go to the About us page'
    },
    featuresTiles: {
      header: {
        title: 'Apps, websites or platforms',
        paragraph: 'We craft web, desktop and mobile applications using leading-edge technology.'
      },
      tiles: [
        {
          title: 'Websites',
          description: 'Need a modern website? AlgorCode builds and publishes it online for you.'
        },
        {
          title: 'Mobile apps',
          description: 'iOS or Android app required? Our team ships it exactly the way you need.'
        },
        {
          title: 'E-commerce',
          description: 'Ready to sell online? We deliver the online store that fits your business.'
        }
      ]
    },
    featuresSplit: {
      header: {
        title: 'The power of technology.',
        paragraph: 'Technology transforms your digital tools and unlocks better outcomes.'
      },
      items: [
        {
          eyebrow: 'Automation for manual processes',
          title: 'Multiply your resources!',
          description: "By automating manual tasks you free people to focus on higher-impact work. Emails, reports, customer support... let's automate it."
        },
        {
          eyebrow: 'Support and service quality',
          title: 'Your system is our priority!',
          description: 'Every system we build goes through thorough testing, and you always have a capable team ready to help.'
        },
        {
          eyebrow: 'Data warehouse',
          title: 'The power of your data.',
          description: 'The more you analyze your data, the better you know your business. Ask about our data analysis offering too!'
        }
      ]
    },
    cta: {
      title: 'How can we help?',
      action: 'Chat with us'
    },
    notFound: {
      title: 'Page not found!',
      description: 'Double-check the address or return to the homepage.'
    },
    notImplemented: {
      title: 'Page not created yet!',
      description: 'This page will be available soon.'
    },
    aboutWelcome: {
      header: {
        title: 'Turning challenges into opportunities',
        paragraph: 'Get to know our recent story and how we turn challenges into opportunities.'
      }
    },
    aboutHistory: {
      header: {
        title: 'Meet our story',
        paragraph: 'Discover how everything started and how we help companies become more efficient.'
      },
      items: [
        {
          eyebrow: 'The start of our story',
          title: 'When it all began',
          description: 'Founded in 2022 to rethink how companies tackle daily challenges. With a team of technology specialists, we create innovative applications that make businesses more productive, efficient and competitive.'
        },
        {
          eyebrow: 'Goals to reach',
          title: 'Targets to achieve',
          description: 'Our goal is to be a strategic partner for clients, offering tailored tech solutions that meet specific needs. We stay ahead of market trends to keep delivering value.'
        },
        {
          eyebrow: 'Driven by our passion for technology',
          title: 'The strategic partner your company needs',
          description: 'We started AlgorCode to change how things are done and believe that together we can achieve amazing results. We look forward to helping your company reach its goals.'
        }
      ]
    },
    contactIntro: {
      title: "Let's talk?",
      description: 'We plan, design and build tailor-made digital solutions. Pick your favorite channel or send a message using the form below.',
      whatsapp: 'Talk on WhatsApp',
      message: 'Write a message'
    },
    contactChannels: {
      header: {
        title: 'How would you like to talk to us?',
        paragraph: 'We are available to answer questions, discuss ideas and understand your project on different channels.'
      },
      whatsapp: {
        title: 'Instant support',
        description: 'Chat with our team on WhatsApp. Monday to Friday, 9am–6pm (BRT).',
        cta: 'Open WhatsApp'
      },
      email: {
        title: 'Send an email',
        description: 'Share project details and get a reply within one business day at {email}.',
        cta: 'Send email'
      },
      meeting: {
        title: 'Projects and proposals',
        description: 'Book a call to define scope, share references and estimate timelines and investment.',
        cta: 'Request a meeting'
      }
    },
    contactForm: {
      header: {
        title: 'Send a message',
        description: 'Share what you need and we will follow up with next steps within one business day.'
      },
      fields: {
        name: {
          label: 'Name',
          placeholder: 'How should we address you?'
        },
        email: {
          label: 'Email',
          placeholder: 'Best email for contact'
        },
        company: {
          label: 'Company',
          placeholder: 'Company name (optional)'
        },
        phone: {
          label: 'Phone',
          placeholder: '(11) 99999-9999'
        },
        message: {
          label: 'Message',
          placeholder: 'Briefly describe the challenges or goals of the project'
        }
      },
      subjectPrefix: 'Website contact',
      fallbackProject: 'new project',
      submit: 'Send message',
      feedback: 'We opened your email app. If it did not work, write to {email}.'
    },
    contactConfirmation: {
      title: 'Thanks for reaching out!',
      description: 'Just wait a bit and we will contact you as soon as possible.'
    },
    careers: {
      hero: {
        title: 'Join our team!',
        description: 'We look for curious, collaborative and outcome-driven people. Here you get autonomy to propose ideas, support to grow and space to work with cutting-edge tech.',
        primaryCta: 'View open roles',
        secondaryCta: 'Send your résumé'
      },
      reasons: {
        header: {
          title: 'Why build with us?',
          paragraph: 'We connect technology, business and collaboration to generate real impact.'
        },
        highlights: [
          {
            title: 'Modern stack',
            description: 'We build products with React, Node, AWS, automation and data to accelerate value delivery.'
          },
          {
            title: 'Autonomy with support',
            description: 'Small teams, continuous feedback and individual growth plans enable daily learning.'
          },
          {
            title: 'Remote culture',
            description: 'We are remote-first, with optional in-person meetups each quarter to keep the team close.'
          },
          {
            title: 'Real impact',
            description: 'We partner with clients from discovery to deploy, always linking technology to results.'
          }
        ]
      },
      openings: {
        header: {
          title: 'Open roles',
          paragraph: 'All opportunities are 100% remote. Applications from anywhere in Brazil are welcome.'
        },
        subjectPrefix: 'Application - ',
        positions: [
          {
            title: 'Senior Front-end Developer',
            type: 'Remote',
            description: 'Leads product evolution, shapes component architecture and mentors the team.',
            tags: ['React', 'TypeScript', 'Design System']
          },
          {
            title: 'Product Designer',
            type: 'Remote',
            description: 'Drives research, prototyping and testing to create simple, consistent multi-channel experiences.',
            tags: ['Discovery', 'Figma', 'Design Ops']
          },
          {
            title: 'QA Engineer',
            type: 'Remote',
            description: 'Builds test strategies, automates key scenarios and ensures delivery observability.',
            tags: ['Automation', 'Cypress', 'CI/CD']
          }
        ],
        cta: 'Apply now',
        fallback: 'No fit for you right now? Email {email} and tell us how you can contribute.'
      },
      process: {
        header: {
          title: 'Our hiring process',
          paragraph: 'Transparency and speed from the first contact to the final feedback.'
        },
        stepLabel: 'Step {step}',
        steps: [
          {
            title: 'Application review',
            description: 'We review résumé, portfolio and links to understand your journey and interests.'
          },
          {
            title: 'Team conversation',
            description: 'A 30-minute chat to get to know you, answer questions and talk about culture.'
          },
          {
            title: 'Light technical challenge',
            description: 'A practical case or pairing session for a collaborative assessment of your skills.'
          },
          {
            title: 'Feedback and offer',
            description: 'Quick feedback for every candidate, plus an invitation to move forward when there is alignment.'
          }
        ]
      },
      finalCta: {
        title: 'Ready to build something big together?',
        description: 'Tell us what you want to create, what challenges motivate you and how we can collaborate.',
        action: 'Get in touch'
      }
    },
    blogFeatured: {
      title: 'AlgorBlog',
      articles: [
        {
          tags: ['Automation', 'Support'],
          title: 'Boost productivity by automating routine tasks with bots and scripts',
          description: 'How chatbots can improve customer experience and simplify support interactions.',
          author: 'By Deoclides Neto - Mar 1, 2017',
          link: '#0'
        },
        {
          tags: ['Soft Skill'],
          title: 'You are never too good for the basics',
          description: 'Everyone wants advanced knowledge. But it is usually the basics that matter most.',
          author: 'By Leonardo Lins - Aug 3, 2022',
          link: '#0'
        },
        {
          tags: ['Artificial Intelligence', 'Computer Vision'],
          title: 'How does a Convolutional Neural Network see the world?',
          description: 'Many state-of-the-art neural nets are readily available to developers today, but how does it actually work?',
          author: 'By Dmitri Eliuseev - Aug 5, 2022',
          link: 'https://medium.com/@dmitryelj/how-the-convolutional-neural-network-see-the-world-a36cd102e7c8'
        }
      ]
    }
  }
};

export default translations;
